import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "sort",
    standalone: false
})
export class OrderbyPipe  implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a ,b ) => ("" + a[field]).localeCompare(b[field],
        undefined, {
        numeric: true
    }));
    return array;
  }
}
